export default __webpack_public_path__ + "static/media/ellipse.5bbb2380.svg";